const NoHeader = () => null;
export function convertToReactTableProps(columns: any) {
	return columns.map(({ key, title, sortable, ...other }: any, i: number) => ({
		Header: title || NoHeader,
		accessor: key || `no_key_${i}`,
		disableSortBy: !sortable,
		...other,
	}));
}
